import {assign} from 'xstate';

const scanningMachine = {
  id: 'scan',
  initial: 'initialize_scanner',
  context: {
      isbn: null,
      message: null,
  },
  states: {
    initialize_scanner: {
      entry: ['createQuagga', assign({ isbn: null, message: null })],
      on: {
       INITIALIZED: 'wait_for_input', 
      },
    },
    wait_for_input: {
      entry: ['startScanning'],
      exit: ['stopScanning'],
      on: {
        ISBN_ENTERED: {
            target: 'process_isbn',
            actions: assign({
                isbn: (context, event) => event.isbn,
            }),
        }
      },
    },
    process_isbn: {
      invoke: {
        id: 'process-isbn',
        src: 'processISBN',
        onDone: {
          target: 'success',
          actions: assign({ message: (_, event) => `Added book ${event.data.title}`}),
        },
        onError: {
          target: 'error',
          actions: assign({ message: (_, event) => event.data }),
        },
      },
    },
    error: {
      on: {
        REPEAT: 'initialize_scanner',
      }
    },
    success: {
      on: {
        REPEAT: 'initialize_scanner',
      }
    },
  }
};

export const mainMachine = {
  id: 'main',
  initial: 'signed_out',
  strict: true,
  context: { email: null },
  states: {
    signed_out: {
      on: {
        SIGNED_IN: {
          target: 'signed_in',
          actions: assign({ email: (_, event) => event.email }),
        },
      }
    },
    signed_in: {
      on: {
        SIGNED_OUT: 'signed_out',
      },
      ...scanningMachine,
    },
  }
};
